export const BASE_API_URL = process.env.VUE_APP_BASE_AUDIT_API_URL;
export const BASE_CDN_URL = process.env.VUE_APP_CDN_URL


export const GET_ALL_REQUESTS = '/request'

export const GET_RECENT_SUBMITTED_REQUESTS = '/request/recent'

export const GET_MOTIONIQ_REQUESTS = '/request/motioniq/recent'

export const GET_RECENT_MOTIONIQ_REQUESTS = '/request/motioniq/recentlist'

export const GET_TENANTS = () => {
    return `/tenants`
}

export const GET_ROSTERS = () => {
    return `/rosters`
}

export const LOGIN_USER = () => {
    return `/user/login`
}

export const GET_TEAMS = (roster_id, timing_date) => {
    return `/roster/${roster_id}/teams?timingdate=${timing_date}`
}
export const GET_PLAYERS = (roster_id, timing_date) => {
    return `/roster/${roster_id}/players?timingdate=${timing_date}`
}

export const PUT_VIDEOREK_REQUEST = (request_id) => {
    return `/request/${request_id}/videorek`
}

export const PUT_CLAIM_REQUEST = (request_id, auditor_id) => {
    return `/request/${request_id}/claim?auditor_id=${auditor_id}`
}

export const GET_REQUEST = (request_id) => {
    return `/request/${request_id}`
}

export const GET_MOTION_REQUEST = (request_id) => {
    return `/request/motioniq/${request_id}`
}

export const GET_OWNER_REQUESTS = (owner_id) => {
    return `/request/owner/${owner_id}`
}

export const GET_OWNER_MOTION_REQUESTS = (owner_id) => {
    return `/request/owner/${owner_id}?motion=true`
}

export const GET_NEXT_REQUEST = (owner_id) => {
    return `/request/next/${owner_id}`
}
export const GET_NEXT_MOTIONIQ_REQUEST = (owner_id) => {
    return `/request/motioniq/next/${owner_id}`
}
export const GET_NEXT_REQUEST_ID = (owner_id) => {
    return `/request/next_id/${owner_id}`
}

export const GET_NEXT_MOTIONIQ_REQUEST_ID = (owner_id) => {
    return `/request/motioniq/next_id/${owner_id}`
}

export const PUT_MOTION_REQUEST_REVIEW = (request_id, auditor_id) => {
    return `/request/${request_id}/review?auditor=${auditor_id}&mode=motioniq`
}
export const PUT_MOTION_REQUEST_TIMING_DATE = (request_id, auditor_id) => {
    return `/request/${request_id}/timingdate?auditor=${auditor_id}&mode=motioniq`
}
export const PUT_REQUEST_TIMING_DATE = (request_id, auditor_id) => {
    return `/request/${request_id}/timingdate?auditor=${auditor_id}&mode=rosteriq`
}
export const PUT_MOTION_REQUEST = (request_id, auditor_id) => {
    return `/request/${request_id}?auditor=${auditor_id}&mode=motioniq`
}

export const PUT_REQUEST_REVIEW = (request_id, auditor_id) => {
    return `/request/${request_id}/review?auditor=${auditor_id}`
}

export const PUT_REQUEST = (request_id, auditor_id) => {
    return `/request/${request_id}?auditor=${auditor_id}`
}

// export const POST_ROSTER_FACEREK = (roster_id) =>{
//     return `/roster/${roster_id}/facerek`
// }

export const POST_PLAYER_REPORT = (request_id, auditor_id) => {
    return `/request/${request_id}/reportPlayer?auditor=${auditor_id}`
}
export const POST_ROSTER_FACEREK = (roster_id, timing_date) => {
    return `/roster/${roster_id}/facerek?timingdate=${timing_date}`
}



// WEBPACK FOOTER //
// ./src/api/urls.js